import { HelpScoutBeacon } from './src/components/utils/HelpScoutBeacon'
import { GlobalStyles } from '@utils/GlobalStyles'
import React from 'react'

// Wrap the entire app to include HelpScoutBeacon on every page
export const wrapRootElement = ({ element }) => {
  return (
    <>
      {element}
      <GlobalStyles />

      {process.env.GATSBY_SHOW_HS_BEACON === 'true' ? (
        <HelpScoutBeacon />
      ) : null}
    </>
  )
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location.hash) {
    setTimeout(() => {
      const hash = document.querySelector(decodeURIComponent(location.hash))
      if (hash) hash.scrollIntoView()
    }, 0)
  } else {
    // navigate to content for support pages
    if (prevLocation && location.pathname.startsWith('/support/')) {
      const content = document.querySelector('#content')
      if (content) {
        content.focus()
      }
    }
  }
}
